import bulkScriptsUpload from "./bulkScriptsUpload.component";
import bulkScriptsUploadUrls from "./bulkScriptsUpload.urls";
import BulkScriptsUploadTransforms from "./bulkScriptsUpload.transforms";

const bulkScriptsUploadModule = angular
  .module("app.components.bulkScriptsUpload", [])
  .component("bulkScriptsUploadPage", bulkScriptsUpload)
  .service("BulkScriptsUploadTransforms", BulkScriptsUploadTransforms)
  .config(bulkScriptsUploadUrls);

export default bulkScriptsUploadModule;



// WEBPACK FOOTER //
// ./src/pages/bulkScriptsUpload/bulkScriptsUpload.module.js